import { AnyAction } from 'redux';
import { ChatHistoryType } from 'domain/types/chatHistory.type';
import { ChatHistoryReducerType } from 'model/reducers/ChatHistoryReducerType';

const initialState: ChatHistoryReducerType = {
  chats: [],
  totalRecords: 0,
  error: null,
};

const chatHistoryReducer = (state = initialState, action: AnyAction): ChatHistoryReducerType => {
  const { type, payload } = action;

  switch (type) {
    case ChatHistoryType.FETCH_CHAT_HISTORY_REQUEST:
      return {
        ...state,
        error: null,
      };

    case ChatHistoryType.FETCH_CHAT_HISTORY_SUCCESS:
      return {
        ...state,
        chats: payload.chats,
        totalRecords: payload.totalRecords,
        error: null,
      };

    case ChatHistoryType.FETCH_CHAT_HISTORY_FAILURE:
      return {
        ...state,
        error: payload.error,
      };

    default:
      return state;
  }
};

export default chatHistoryReducer;
